// extracted by mini-css-extract-plugin
export var column = "_ta-0";
export var divider = "_ta-2";
export var timePicker = "_ta-1";